/**
 * The HTTP status of a failed $fetch, or undefined when no response came back
 * @param {unknown} error
 * @returns {number | undefined}
 */
export function errorStatus(error) {
  return error?.response?.status ?? error?.statusCode
}
